/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, total: NonNullable<unknown> }} Platform_Pass_LeftInputs */

const en_platform_pass_left = /** @type {(inputs: Platform_Pass_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.total} used`)
};

const pl_platform_pass_left = /** @type {(inputs: Platform_Pass_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wykorzystane ${i?.used} z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{used} of {total} used" |
*
* @param {Platform_Pass_LeftInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pass_left = /** @type {((inputs: Platform_Pass_LeftInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pass_LeftInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pass_left(inputs)
	return en_platform_pass_left(inputs)
});